import { useContext, useEffect, useState } from 'react';
import { useOutletContext, useParams } from 'react-router';

import { PlaceOutletContextType } from "../home/PlacesHome";
import { Lead, NotificationType } from 'shared/topchef.types';
import placesApi from 'shared/topchef-api-places';
import Loading from 'pages/shared/loading/Loading'
import { NotificationContext } from 'shared/NotificationContext'
import LeadContent from 'pages/shared/lead-content/LeadContent'
import { useErrorBoundary } from 'react-error-boundary'

const SharedLeadDetails = () => {

  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const params = useParams();
  const leadId: string = params.leadId || '';

  const [isReady, setReady] = useState<boolean>(false);
  const [currentLead, setCurrentLead] = useState<Lead | null>(null);

  const { showBoundary } = useErrorBoundary();

  useEffect(() => {

    async function loadLead() {
      try {
        const lead: Lead = await placesApi.loadSharedLead(loggedInPlace!.id, leadId);
        setCurrentLead(lead);
        setReady(true);
      } catch (error: any) { 
        const newError = new Error(`Problème pour récupérer les détails du brief : '${error.message}'`);
        triggerNotification({type: NotificationType.error, message : newError.message});
        return showBoundary(newError);
      } 
    }

    if (isReady) {
      return;
    }

    loadLead();

  }, [currentLead, isReady, leadId, loggedInPlace, showBoundary, triggerNotification]);


  if (!isReady) {
    return (
      <Loading />
    );
  }

  return (
    <div className="container page-briefs-single-details p-2 col-md-6 overflow-auto">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">Ajouter un brief</a></li>
        </ul>
      </div>
     
      <LeadContent lead={currentLead!} />

    </div>
  );

}


export default SharedLeadDetails;
